import { useDialogStore, type DialogOptions } from './store';

export function useDialog() {
  const show = useDialogStore((s) => s.show);

  return {
    alert: (title: string, message?: string, opts: Partial<DialogOptions> = {}) =>
      show('alert', { title, message, ...opts }),
    confirm: (title: string, message?: string, opts: Partial<DialogOptions> = {}) =>
      show('confirm', { title, message, ...opts }),
    prompt: (
      title: string,
      message: string | undefined,
      defaultValue: string,
      opts: Partial<DialogOptions> = {},
    ) =>
      show('prompt', {
        title,
        message,
        inputDefaultValue: defaultValue,
        ...opts,
      }),
  };
}
